var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3860_2192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.5C14.6 5.5 15.5 4.6 15.5 3.5C15.5 2.4 14.6 1.5 13.5 1.5C12.4 1.5 11.5 2.4 11.5 3.5C11.5 4.6 12.4 5.5 13.5 5.5ZM9.8 8.9L7.24 21.81C7.11 22.42 7.59 23 8.22 23H8.3C8.77 23 9.17 22.68 9.28 22.22L10.9 15L13 17V22C13 22.55 13.45 23 14 23C14.55 23 15 22.55 15 22V16.36C15 15.81 14.78 15.29 14.38 14.91L12.9 13.5L13.5 10.5C14.57 11.74 16.12 12.63 17.86 12.91C18.46 13 19 12.52 19 11.91C19 11.42 18.64 11.01 18.15 10.93C16.63 10.68 15.37 9.78 14.7 8.6L13.7 7C13.14 6.11 12.02 5.75 11.05 6.16L7.22 7.78C6.48 8.1 6 8.82 6 9.63V12C6 12.55 6.45 13 7 13C7.55 13 8 12.55 8 12V9.6L9.8 8.9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3860_2192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHike);
export default __webpack_public_path__ + "static/media/hike.a21917be702f2352ffd6434ecc4c0f76.svg";
export { ForwardRef as ReactComponent };